import { useEffect, type ReactNode } from 'react';
import { cls } from '../lib/util';

/** Bottom action sheet (phone) / centred dialog (desktop). Escape or backdrop closes. */
export function Sheet({ open, onClose, title, children, className, wide }: { open: boolean; onClose: () => void; title?: ReactNode; children: ReactNode; className?: string; wide?: boolean }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow; document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="sheet-bg" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={cls('sheet', wide && 'wide', className)} role="dialog" aria-modal="true" aria-label={typeof title === 'string' ? title : undefined}>
        <div className="grip" aria-hidden="true" />
        {title && <h3 className="sheet-title">{title}</h3>}
        {children}
      </div>
    </div>
  );
}
